import { Adresse } from "@e-forsyning/common/adresse";

export class ValidererAdresseKodeResult {
    public adresse: Partial<Adresse>;
    public adresseKode: string;
}
